import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModulePackage } from '@app/interfaces/packages/module-package';

export interface ModuleTierChoiceDialogData {
  packages: ModulePackage[];
  currentPackageUuid: string | null;
}

export interface ModuleTierChoiceDialogResult {
  selectedPackage: ModulePackage | null;
}

@Component({
  selector: 'app-module-tier-choice-dialog',
  templateUrl: './module-tier-choice-dialog.component.html',
  standalone: false,
})
export class ModuleTierChoiceDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ModuleTierChoiceDialogData,
    private dialogRef: MatDialogRef<ModuleTierChoiceDialogComponent, ModuleTierChoiceDialogResult>
  ) {
  }

  isCurrent(pkg: ModulePackage): boolean {
    return pkg.uuid === this.data.currentPackageUuid;
  }

  selectPackage(pkg: ModulePackage): void {
    if (this.isCurrent(pkg)) {
      return;
    }
    this.dialogRef.close({ selectedPackage: pkg });
  }

  cancel(): void {
    this.dialogRef.close({ selectedPackage: null });
  }

  static open(dialog: MatDialog, data: ModuleTierChoiceDialogData): MatDialogRef<ModuleTierChoiceDialogComponent> {
    return dialog.open(ModuleTierChoiceDialogComponent, {
      width: '640px',
      maxWidth: '95vw',
      disableClose: false,
      data
    });
  }
}
